module.exports = __webpack_public_path__ + "static/img/kia.0bdace4.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/partner/kia.gif
// module id = /s8z
// module chunks = 0